import { ICampaignDetailsState, ICampaignEanexSubmitData } from "../../../app/store/campaign/details/types";
import { CampaignConstants } from "../../../constants/CampaignConstants";
import CampaignSubmitDataEanexFactory from "../../../factories/campaigns/CampaignSubmitDataEanexFactory";

export default class CampaignEanexSubmit {

  public action: string;
  public data: ICampaignEanexSubmitData;

  constructor(campaignDetailsState: ICampaignDetailsState, hash: string) {
    this.action = CampaignConstants.submitActions.EANEX;
    this.data = CampaignSubmitDataEanexFactory.create(campaignDetailsState, hash);
  }

}
